var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-window', {
    model: {
      value: _vm.stepLocal,
      callback: function callback($$v) {
        _vm.stepLocal = $$v;
      },
      expression: "stepLocal"
    }
  }, [_c('v-window-item', {
    attrs: {
      "value": _vm.RepairEstimateSteps.SELLER
    }
  }, [_c('repair-estimate-party-form', {
    ref: "sellerForm",
    attrs: {
      "partnerId": _vm.value.partnerId,
      "title": _vm.$t('objects.repairEstimate.seller')
    },
    model: {
      value: _vm.value.seller,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "seller", $$v);
      },
      expression: "value.seller"
    }
  }), _c('div', {
    staticClass: "mt-6"
  }), _c('select-entity', {
    staticClass: "mt-4",
    attrs: {
      "refType": _vm.ResourceEnum.REPORT,
      "partnerId": _vm.value.partnerId,
      "label": _vm.$t('objects.repairEstimate.reportId'),
      "hint": _vm.$t('objects.repairEstimate.reportIdHint'),
      "clearable": true
    },
    model: {
      value: _vm.value.reportId,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "reportId", $$v);
      },
      expression: "value.reportId"
    }
  }), _vm.categories.length ? _c('div', [_c('v-subheader', [_vm._v(" " + _vm._s(_vm.$t("repairEstimate.documentsRelatedToEstimateLikeReport")) + " ")]), !_vm.hideRefsSelect ? _c('refs-select', {
    attrs: {
      "partnerId": _vm.value.partnerId,
      "listMode": _vm.refsSelectAsList,
      "hideSuggestions": true,
      "hideEditButton": true,
      "categories": _vm.categories,
      "isConfirmable": false
    },
    model: {
      value: _vm.value.refs,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "refs", $$v);
      },
      expression: "value.refs"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _c('v-window-item', {
    attrs: {
      "value": _vm.RepairEstimateSteps.EXPIRATION
    }
  }, [_c('v-date-picker', {
    attrs: {
      "outlined": "",
      "full-width": ""
    },
    model: {
      value: _vm.value.dateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "dateFormable", $$v);
      },
      expression: "value.dateFormable"
    }
  })], 1), _c('v-window-item', {
    attrs: {
      "value": _vm.RepairEstimateSteps.SEND_MAIL
    }
  }, [_vm.RepairEstimateSteps.SEND_MAIL === _vm.stepLocal ? _c('preselect-template-card', {
    ref: "templateCard",
    staticClass: "mt-1",
    attrs: {
      "templateKey": _vm.PreselectTemplateKeysEnum.REQUEST_REPAIR_ESTIMATE_MAIL,
      "language": _vm.partner.language,
      "partnerId": _vm.value.partnerId,
      "from": [_vm.partner],
      "context": _vm.context,
      "to": _vm.value.seller ? [_vm.value.seller.email] : [],
      "refs": [{
        refId: this.value.id,
        refType: _vm.ResourceEnum.REPAIR_ESTIMATE
      }]
    }
  }) : _vm._e(), _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "elevation": 0
    },
    on: {
      "click": function click() {
        return _vm.sharedContent.copyUrl();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("timeLine.ActivityTimeLineItemShare.btnText")) + " ")])], 1)], 1), _c('v-window-item', {
    attrs: {
      "value": _vm.RepairEstimateSteps.SUCCESS
    }
  }, [_c('v-img', {
    staticClass: "mt-5 mb-5",
    attrs: {
      "align": "center",
      "justify": "center",
      "contain": "",
      "max-height": "200px",
      "src": require("@/assets/undraw/undraw_add_files_re_v09g.svg")
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }